import androidx.compose.ui.ExperimentalComposeUiApi
import androidx.compose.ui.window.ComposeViewport
import com.github.terrakok.tuner.App

@OptIn(ExperimentalComposeUiApi::class)
fun main() = ComposeViewport { App() }
